<template>
  <v-app style="height: auto; background-color: var(--v-background-base)">
    <OpenLinkInTab :data="$openLinkInTabOptions" />
    <template v-if="$route.meta.public === false && $store.state.user">
      <TopBar />
      <NavBar />
      <v-main id="page-wrapper">
        <TransitionPage>
          <router-view :key="$route.fullPath"></router-view>
        </TransitionPage>
      </v-main>
      <be-modal-message
        :show="modalMessage.show"
        :message="modalMessage.message"
        :color="modalMessage.color"
        @refreshPage="modalMessage.refreshPage()"
      />
      <v-snackbar
        v-model="snackbar.show"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        {{ snackbar.text }}
      </v-snackbar>
      <HelpIA></HelpIA>
    </template>
    <template v-else>
      <transition v-if="$route.meta.public === true">
        <keep-alive>
          <router-view :key="$route.fullPath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <Modal :dialog_params="dialog_params" />
    <ModalOver :dialog_params_over="dialog_params_over" />
    <DeleteModal :dialog_params_delete="dialog_params_delete" />
    <StoryLaneEmbed
      :embedHash="tourHash"
      :show="showStoryLanePopUp"
      @close="showStoryLanePopUp = false"
    />
    <div class="footer mt-3"></div>
  </v-app>
</template>

<script>
import TransitionPage from "@/components/TransitionPage.vue";
import NavBar from "@/components/NavBar";
import TopBar from "@/components/TopBar";
import Modal from "@/components/Layout/Modal";
import ModalOver from "@/components/Layout/ModalOver";
import DeleteModal from "@/components/Layout/DeleteModal";
import BeModalMessage from "be-components/components/ModalMessage";
import HelpIA from "@/components/HelpIA";
import StoryLaneEmbed from "@/components/StoryLaneEmbed/StoryLaneEmbed.vue"
import { EventBus } from './eventBus'

export default {
  name: "App",
  components: {
    NavBar,
    TopBar,
    TransitionPage,
    Modal,
    ModalOver,
    DeleteModal,
    BeModalMessage,
    HelpIA,
    StoryLaneEmbed,
  },

  data() {
    return {
      dialog_params: { show: false },
      dialog_params_over: { show: false },
      dialog_params_delete: { show: false },
      modalMessage: this.defaultModalMessage(),
      snackbar: this.defaultSnackbar(),
      showStoryLanePopUp: false,
      tourHash: "wmpair9wslhc"
    };
  },

  computed: {
    textSize() {
      return this.$store?.state?.textSize;
    },
  },

  created() {
    const thisInstance = this;
    this.$root.$on("Modal-Show", function(dialog_params) {
      thisInstance.dialog_params = dialog_params;
      thisInstance.dialog_params.show = true;
    });
    this.$root.$on("Modal-Show-Error", function(type) {

      let title = ''

      switch(type) {
        case 'delete':
          title = "Não foi possível excluir. Por favor, tente novamente."
          break
        case 'required-val':
          title = "Por favor preencha todos os campos obrigatórios e verifique o formato correto dos campos."
          break
        case 'validation':
          title = "Erro de validação!"    
          break
        default:
          title = "Não foi possível salvar. Por favor, tente novamente."  
      }

      thisInstance.dialog_params = {
        size: "700px",
        show: true,
        title: title,
        type: "error",
      };
      thisInstance.dialog_params.show = true;
    });
    this.$root.$on("Modal-Show-Success", function(type) {
      thisInstance.dialog_params = {
        size: "700px",
        show: true,
        title: type === "save" ? "Salvo com sucesso!" : "Excluído com sucesso!",
        type: null,
      };
      thisInstance.dialog_params.show = true;
    });
    this.$root.$on("Modal-Hide", function(dialog_params) {
      thisInstance.dialog_params.show = false;
    });

    this.$root.$on("Modal-Show-Over", function(dialog_params) {
      thisInstance.dialog_params_over = dialog_params;
      thisInstance.dialog_params_over.show = true;
    });
    this.$root.$on("Modal-Hide-Over", function(dialog_params) {
      thisInstance.dialog_params_over.show = false;
    });

    this.$root.$on("Modal-Show-Delete", function(dialog_params) {
      thisInstance.dialog_params_delete = dialog_params;
      thisInstance.dialog_params_delete.show = true;
    });
    this.$root.$on("Modal-Hide-Delete", function(dialog_params) {
      thisInstance.dialog_params_delete.show = false;
    });
    this.$root.$on("globalModalMessage", data => {
      this.modalMessage = data;
    });
    this.$root.$on("resetGlobalModalMessage", () => {
      this.modalMessage = this.defaultModalMessage();
    });
    this.$root.$on("globalSnackbar", data => {
      this.snackbar = data;
    });

    const storyLaneScript = document.createElement("script");
    storyLaneScript.src = "https://js.storylane.io/js/v2/storylane.js";
    storyLaneScript.async = true;
    document.body.appendChild(storyLaneScript);

    EventBus.$on('tour', this.handleTour);
  },

  mounted() {
    this.handleStoryLanePopUp();
  },

  beforeDestroy() {
    EventBus.$off('tour', this.handleTour);
  },

  methods: {
    defaultModalMessage: () => {
      return {
        show: false,
        color: "",
        message: {
          title: "",
        },
        refreshPage: () => {},
      };
    },
    defaultSnackbar: () => {
      return {
        show: false,
        text: "",
        color: "",
        timeout: 2000,
      };
    },
    handleStoryLanePopUp() {
      setTimeout(() => {
        const enabledProfiles = ["compliance", "requests_manager"];
        const showPopUp = JSON.parse(localStorage.getItem("showStoryLanePopUp"));

        if (this.$store.getters.hasUserProfiles(enabledProfiles)) {
          if (!showPopUp) {
            this.showStoryLanePopUp = true;

            localStorage.setItem("showStoryLanePopUp", 1);
          }
        }
      }, 3000);
    },
    handleTour(hash) {
      this.tourHash = hash
      this.showStoryLanePopUp = true
    }
  },

  watch: {
    $route: function(val) {
      if (val.name != "Login" && !val.meta.public) {
        if (this.hasUser) return;
        this.$store.getters
          .loadUser()
          .then(user => {
            if (
              user.profiles.indexOf("compliance") !== -1 &&
              user.extend.terms_of_use == false
            ) {
              // this.$router.push({ name: 'Login' })
              // return
            }
            this.hasUser = true;
          })
          .catch(err => {
            this.hasUser = false;
          });
      }
    },
    textSize: {
      immediate: true,
      handler(val) {
        if (val) {
          document.querySelector("html").style.fontSize = `${val}%`;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  margin-top: 60px;
}
</style>
